import $ from 'jquery';
import { message } from 'antd'
import CONFIG from './config'
import User from './user';
import Bus from './TBus'
declare var window: any;

function request(method: string, url: string, params: any, option: any) {
  if (window.location.href.indexOf('/public') !== -1 && window.userAdminInfo.adminId !== User.aid()) {
    window.location.reload();
    // return {}
  }
  return new Promise(function (resolve, reject) {
    let query: any = {
      p: 'w',
      v: CONFIG.version,
      userType: 'B'
    }
    if (option && !option.noCache) {
      query.token = User.token();
      query.uid = User.uid();
    }
    if (params && typeof params.query === 'object') {
      query = { ...query, ...params.query };
      delete params.query;
    }
    if (User.aid() && !option.instType) {
      query.aid = User.aid();
    } else if (User.cid() && option.instType === 'center') {
      query.cid = User.cid();
    }

    if (query) {
      url += '?' + $.param(query);

    }
    // console.log(User.aid(), 'User.aid()')
    const aURL = url;
    url = CONFIG.api + aURL;
    const ajaxOptions = {
      data: params,
      method: method || 'POST',
      url,
      timeout: 20000,
      contentType: option.contentType || 'application/x-www-form-urlencoded; charset=UTF-8',
      headers: {
        userType: 'B',
        p: 'w',
        deviceType: 'w',
        aid: User.aid() || "",
        bizAccountId: User.aid() || "",
        cid: User.cid() || "",
        orgAdminId: User.cid() || '',
        uid: User.uid() || '',
        userId: User.uid() || '',
        token: User.token() || '',
        xmToken: User.token() || '',
        v: 'v5.0.0',
        xmVersion: window.NewVersion ? '5.0' : '4.0',
        instId: (!!window.currentUserInstInfo && window.currentUserInstInfo.instId) || localStorage.getItem('instId') || ''
      },

      dataType: option.dataType || 'json',
      processData: option.processData || true,
      beforeSend(xhr: any) {
        Bus.trigger('spin', true)
        option.beforeSend && option.beforeSend(xhr);
      },
      success(res: any) {
        Bus.trigger('spin', false)
        // console.log(res)
        if (res.success || res.resultCode === 0) {
          resolve(res);
        } else if (res.resultCode === 1) {
          window.XMHistory.push('/login')
        } else if (res.code === 'LOGIN_OVERDUE') {
          reject(res)
        } else {
          if (url.indexOf('/searchStudentByFace') === -1) {
            processRequestError(res);
          }
          reject(res);
        }
      },
      error(xhr: any) {
        Bus.trigger('spin', false)
        if (xhr.status === 401) {
          window.XMHistory.push('/login')
        } else {
          if (url.indexOf('/searchStudentByFace') === -1) {
            processHttpError(xhr);
          }
          reject(xhr);
        }
      }
    }

    $.ajax(ajaxOptions);

    // }
  });

}

function processRequestError(res: any) {
  message.error(res.message || res.resultMsg);
}

function processHttpError(xhr: any) {
  if (xhr.status === 400) {
    message.error('请正确填写数据！错误码（400）');
  } else if (xhr.status === 403) {
    localStorage.clear();
    window.location.reload()
    // message.error('权限不足，请联系管理员(主账号)');
  } else if (xhr.status === 500) {
    message.error('服务端发生错误！错误码（500）');
  } else if (xhr.status === 404) {
    message.error('服务端未处理该请求！错误码（404）');
  } else {
    message.error('服务端开小差了，请稍后再试~');
  }
}

function sobotRequest(action: string, data: any) {
  const param = {
    action,
    data,
    access_token: localStorage.getItem("access_token")
  }
  const url = 'https://dev-sobot.xiaomai5.com/open/platform/api.json'
  return new Promise(function (resolve, reject) {
    const ajaxOptions = {
      data: JSON.stringify(param),
      method: 'POST',
      url,
      timeout: 20000,
      headers: {
        "Content-Type": 'application/json; charset=UTF-8',
      },

      dataType: 'json',
      processData: true,
      success(res: any) {
        resolve(res);
      },
      error(res: any) {
        reject(res)
      }
    }

    $.ajax(ajaxOptions);
  })
}


class Axios {
  static get(url: string, params = {}, option = {}) {
    return request('get', url, params, option);
  }
  static post(url: string, params = {}, option = {}) {
    return request('post', url, params, option);
  }
  static postJSON(url: string, params: any = {}, option: any = {}) {
    option = option || {};
    option.contentType = 'application/json; charset=UTF-8';
    return request('post', url, JSON.stringify(params), option);
  }

  static sobot(action: string, data: any) {
    return sobotRequest(action, data)
  }

  static Business(url: string, params: any = {}, option: any = {}) {
    return this.postJSON(`business/${url}`, params, option)
  }


}


export default Axios;